import app from 'flarum/forum/app';
function tagSlug(tag) {
  try {
    return typeof tag.slug === 'function' ? tag.slug() : '';
  } catch (e) {
    return '';
  }
}
export function findTagBySlug(slug) {
  if (!slug || !app.store) {
    return null;
  }
  try {
    return app.store.all('tags').find(tag => {
      try {
        return tagSlug(tag).localeCompare(slug, undefined, {
          sensitivity: 'base'
        }) === 0;
      } catch (e) {
        return false;
      }
    }) || null;
  } catch (e) {
    return null;
  }
}
export function childTagsOf(parent) {
  const children = [];
  const seen = {};
  if (!parent) {
    return children;
  }
  const add = tag => {
    if (!tag || typeof tag.id !== 'function') {
      return;
    }
    const id = tag.id();
    if (!id || seen[id]) {
      return;
    }
    seen[id] = true;
    children.push(tag);
  };
  try {
    if (typeof parent.children === 'function') {
      const raw = parent.children();
      if (Array.isArray(raw)) {
        raw.forEach(add);
      }
    }
  } catch (e) {
    // Relation may be unloaded.
  }
  try {
    const parentId = parent.id();
    app.store.all('tags').forEach(tag => {
      if (!tag || tag === parent) {
        return;
      }
      try {
        if (typeof tag.parent === 'function') {
          const p = tag.parent();
          if (p && typeof p.id === 'function' && p.id() === parentId) {
            add(tag);
            return;
          }
        }
        if (typeof tag.isChild === 'function' && tag.isChild() && typeof tag.parent === 'function') {
          const p = tag.parent();
          if (p && typeof p.id === 'function' && p.id() === parentId) {
            add(tag);
          }
        }
      } catch (e) {
        // Ignore unload errors for a single tag.
      }
    });
  } catch (e) {
    // Store may not be ready.
  }
  return children.sort((a, b) => {
    const pa = typeof a.position === 'function' ? a.position() || 0 : 0;
    const pb = typeof b.position === 'function' ? b.position() || 0 : 0;
    return pa - pb;
  });
}
export function tagHref(tag) {
  try {
    if (typeof app.route.tag === 'function') {
      return app.route.tag(tag);
    }
    return app.route('tag', {
      tags: tagSlug(tag)
    });
  } catch (e) {
    return '/t/' + encodeURIComponent(tagSlug(tag));
  }
}
export function isChildTag(tag) {
  if (!tag) {
    return false;
  }
  try {
    if (typeof tag.isChild === 'function' && tag.isChild()) {
      return true;
    }
    if (typeof tag.parent === 'function') {
      return !!tag.parent();
    }
  } catch (e) {
    return false;
  }
  return false;
}
export function tagFromListState(state) {
  const slug = state && state.params && state.params.tags;
  if (slug) {
    const found = findTagBySlug(slug);
    if (found) {
      return found;
    }
  }
  if (typeof app.currentTag === 'function') {
    try {
      return app.currentTag() || null;
    } catch (e) {
      return null;
    }
  }
  return null;
}